import type { SVGProps } from 'react';

const MetropolisLocations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M11.8929 18.5H7.25544C6.99336 18.5001 6.73793 18.5826 6.52529 18.7358C6.31264 18.889 6.15353 19.1052 6.07044 19.3537L3.56544 26.8538C3.50265 27.0416 3.4854 27.2418 3.51514 27.4376C3.54487 27.6335 3.62074 27.8195 3.73647 27.9803C3.85221 28.141 4.0045 28.272 4.18079 28.3624C4.35709 28.4527 4.55234 28.4999 4.75044 28.5H27.2504C27.4484 28.4998 27.6435 28.4527 27.8197 28.3624C27.9958 28.2721 28.148 28.1412 28.2637 27.9806C28.3794 27.82 28.4554 27.6342 28.4852 27.4385C28.5151 27.2428 28.498 27.0428 28.4354 26.855L25.9354 19.355C25.8525 19.106 25.6933 18.8894 25.4804 18.7359C25.2675 18.5825 25.0117 18.4999 24.7492 18.5H20.1092M23.5004 11C23.5004 15.5162 18.6642 20.2863 16.7592 21.9938C16.5413 22.1602 16.2747 22.2504 16.0004 22.2504C15.7262 22.2504 15.4596 22.1602 15.2417 21.9938C13.3379 20.2863 8.50044 15.5162 8.50044 11C8.50044 9.01088 9.29062 7.10322 10.6971 5.6967C12.1037 4.29018 14.0113 3.5 16.0004 3.5C17.9896 3.5 19.8972 4.29018 21.3037 5.6967C22.7103 7.10322 23.5004 9.01088 23.5004 11ZM18.5004 11C18.5004 12.3807 17.3812 13.5 16.0004 13.5C14.6197 13.5 13.5004 12.3807 13.5004 11C13.5004 9.61929 14.6197 8.5 16.0004 8.5C17.3812 8.5 18.5004 9.61929 18.5004 11Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MetropolisLocations;
